export default "<div class=\"text-section-title-container\">\r\n  <h2>{{text.title}}</h2>\r\n  <p>{{text.subtitle}}</p>\r\n</div>";